import React, { Component } from "react";
import styled from "styled-components";
import { Flex, Link, Button } from "../../components";
import { history } from "../../utils";
import ProgressBar from "../../components/ProgressBarLive";
import vars from "../../vars";
import Modal from "./Modal";
import Modal1 from "./Modal1";
import moment from 'moment';
import 'katex/dist/katex.min.css';
import LayoutWrapper from '../../components/LayoutWrapper';
import Equation from '../../components/Equation';
import Report from '../../components/Report/Report';
import {addQuestionBookmark, deleteQuestionBookmark, getLiveQuestion, getLiveTestEndTime, submitLiveQuestion} from '../../lib/api';
import Shimmer from '../../components/shimmer';

const Box = styled.div`
  margin: 0 0 0.5em 0;
  padding-top: 0.2em;
  font-weight: bold;
  border-radius: 4px;
  background:white;
  transition: all 0.3s cubic-bezier(.25,.8,.25,1);
`;

const Image = styled(Flex)`
  height: 15rem;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

const Hint = styled(Flex)`
  padding: 0.3em 0;
  span{
    color: #4E54C8;
    font-size: 14px;
    // font-weight: bold;
  },
  svg {
    color: ${vars.brand_color};
    padding: 0.5em 0;
  }
`;

const QuestionOverviewWrapper = styled.div`
  display:initial;
  @media (max-width: 767px) {
    display: none;
  }
`
const ActionButtons = styled.div`
  @media(max-width:767px){
    display:none;
  }
`

const GridLayout = styled.div`
  display: grid;
  grid-template-columns: 3fr 1fr;
  grid-gap: 2rem;
  @media (max-width: 768px) {
    grid-template-columns: auto;
  }
`;

const Hex = () => (
  <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 300 300">
    <polygon points="300,150 225,280 75,280 0,150 75,20 225,20" />
  </svg>
);

const Hexagon = styled(Flex)`
  a {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 3em;
    height: 3em;
    cursor: pointer;
    text-decoration: none;
    span {
      color: #000;
      z-index: 1;
    }
  }

  svg {
    position: absolute;
    fill: ${({ blue, yellow }) =>
    blue ? "#42A5F5" : yellow ? "#eed94a" : "#ccc"};
    width: 100%;
    height: 100%;
    polygon {
      stroke: ${({ active }) => (active ? vars.brand_color : "transparent")};
      stroke-width: 10px;
      transition: all 0.3s esae;
    }
    transition: all 0.3s esae;
  }
`;

const QuestionsOverview = styled.div`
  display: grid;
  grid-template-columns: repeat(4, auto);
  grid-gap: 1em;
`;

class TestStart extends Component {
  state = {
    modalOpen: false,
    testSubmittedModalOpen: false,
    windowChangeWarningModalOpen: false,
    questionnaire_id: this.props.tid,
    
    question: null,
    questions: [],
    answer: {
      question_id: null,
      question_option_id: null,
      timetaken: [],
      screenshot: 0,
      isBookMarked: false
    },
    questionSubmitting: false,
    testSubmitting: false,
    total_timetaken: 0,
    visitedTimeStamp: null,
    questionVisitDuration: 0,
    offline: false,
    testSubmittedFromMulitpleFraud:false,
    showShimmer: false,
    pageMounted:false,
    event:null,
    noOfWindowSwitches:0,
    dialogTitle: 'Are you sure you want to submit the test ?',
    selected_option: null
  };

  componentDidMount = async () => {
    window.addEventListener("online", () => {
      this.setState({ offline: false });
    }, false);
    window.addEventListener("offline", () => {
      this.setState({ offline: true });
    }, false);
    document.body.style.background = 'white';
    var questionReceived = false;
    var tid = this.props.tid;
    while (!questionReceived) {
      let data = await getLiveQuestion(tid)
      if (data.status == 200 ) {
        let questions = this.state.questions;
        questions.push(data.data);
        let strattime = moment();
        this.setState({question: data.data, questions: questions, question_starttime : strattime, question_endtime: null});
        questionReceived = true;
        break;
      } else if (data.status == 500){
        let getEndData = await getLiveTestEndTime(tid);
        if (getEndData.status == 200 ) {
          if (getEndData.ended == 1) {
            this.setState({testEnded: true, testEndedTime : getEndData.end_time})
            questionReceived = true
            history.push(`/liveTestOverview/${tid}`);
              break;
          }
        }
      }
      
    }
  }
  
  checkNative = () => {
    try {
      if ((window.webkit) || window.appInterface)
        return true;
      else return false;
    } catch (error) {
      console.log(error);
    }
  }

  callbackToNative = (msg) => {
    try {
      console.log('calling back native' + msg)
      if (window.webkit != undefined) {
        window.webkit.messageHandlers.observe.postMessage(msg);
        window.webkit.messageHandlers.appInterface.postMessage(msg)
      }
      if (window.appInterface != undefined) {
        window.appInterface.postMessage(msg)
      }
    } catch (error) {
      console.log(msg);
      console.log(error);
    }
  }

  componentWillMount() {
    localStorage.removeItem('lastX');
    localStorage.removeItem('lastScrollLeftPosition');
  }

  handleSubmit = async () => {
    if (this.state.offline) {
      this.callbackToNative("done");
      this.setState({ modalOpen: false });
      return;
    }
    var tid = this.props.tid;
    if (this.state.testSubmitting) return;
    this.setState({ testSubmitting: true , testSubmittedModalOpen: true, dialogTitle: 'Submitting the question', showANswer: true});
    console.log('submitTest')
    let end_time = moment();
    let answer = this.state.answer;
    answer.question_id = this.state.question.id;
    answer.timetaken = end_time.diff(this.state.question_starttime, 'seconds')
    console.log(answer.timetaken)
    answer.question_option_id = this.state.selected_option;
    console.log(answer)
    let success = await submitLiveQuestion(tid, this.state.question.id, answer);
    console.log(success)
    this.setState({ testSubmitting: false, testSubmittedModalOpen: false, dialogTitle: '', showAnswer: true });
    if (success) {
      // if(this.state.testSubmittedFromMulitpleFraud) {
      //   return;
      // }
      this.setState({ testSubmittedModalOpen: true, dialogTitle: 'Question has been submitted. Waiting for another question'})
      var question_fetched = false;
      while (!question_fetched) {
        let data = await getLiveQuestion(tid)
        if (data.status == 200 ) {
          let questions = this.state.questions;
          questions.push(data.data);
          let strattime = moment();
          this.setState({showAnswer: false,testSubmittedModalOpen: false,selected_option:null, dialogTitle: '',question: data.data, questions: questions, question_starttime : strattime, question_endtime: null});
          question_fetched = true;
          break;
        } else if (data.status == 500){
          let getEndData = await getLiveTestEndTime(tid);
          if (getEndData.status == 200 ) {
            if (getEndData.ended == 1) {
              this.setState({testEnded: true, testEndedTime : getEndData.end_time, testSubmittedModalOpen: true, dialogTitle: 'Test has been ended!!!'})
              question_fetched = true
              history.push(`/liveTestOverview/${tid}`);
              break;
            }
          }
        }
        
      }
      // this.setState({showAnswer: true, testSubmittedModalOpen: false, dialogTitle: ''})
    } else {
      alert("Something goes wrong, please submit again!");
    }
  };

  handleModalToggle = () => {
    if (this.state.offline) {
      this.setState({
        dialogTitle: 'Your not connected to active internet.',
        modalOpen: true
      });
      return;
    } else {
      this.setState({ modalOpen: !this.state.modalOpen, dialogTitle: 'Are you sure you want to submit the test ?' });
    }
  };

  handleBookMark = () => {
    let { tid, qid, questions } = this.props;
    this.setState(prevState => {
      let question = prevState.question_answers.find(
        ({ question_id }) => question_id === questions[qid].id
      );
      question.question_option_id = null;
      question.isBookMarked = true;
      return prevState;
    });
  };

  updateTimers = () => {
    this.setState(prevState => {
      let datetime = moment().format('YYYY-MM-DD hh:mm:ss').toString();
      if (!prevState.visitedTimeStamp) {
        prevState.visitedTimeStamp = datetime
      };
      prevState.total_timetaken = prevState.total_timetaken + 1;
      prevState.questionVisitDuration = prevState.questionVisitDuration + 1
      return prevState;
    });
  }

  handleCheck = (id, is_answer) => {
    // let { tid, qid, questions } = this.props;
    // this.setState(prevState => {
    //   let question = prevState.question_answers.find(
    //     ({ question_id }) => question_id === questions[qid].id
    //   );
    //   question.question_option_id = id;
    //   question.isBookMarked = false;
    //   question.is_answer = is_answer;
    //   return prevState;
    // });
    this.setState({selected_option: id})
  };

  addOrDeleteBookmark = async () => {
    let is_bookmarked = this.props.questions[this.props.qid].is_bookmarked;
    let id = this.props.questions[this.props.qid].id
    if (is_bookmarked === 0) {
      let response = await addQuestionBookmark(id);
      if (response.status === 200) {
        this.props.questions[this.props.qid].is_bookmarked = 1
      }
    } else if(is_bookmarked === 1) {
      let response = await deleteQuestionBookmark(id);
      if (response.status === 200) {
        this.props.questions[this.props.qid].is_bookmarked = 0
      }
    }
  };

  render() {
    let { tid, qid, description } = this.props;
    // let { question_answers, modalOpen, testSubmittedModalOpen, windowChangeWarningModalOpen} = this.state;
    let pattern = /\$.*?\$/gm;
    // let progress = ((+(qid) + 1) / questions.length) * 100;
    // let greyWidth = 100 - progress;
    if (!this.state.question) {
      return (
        <div style={{margin: 'auto', textAlign: 'center', marginTop: '150px'}}>
          Please wait for the question
        </div>
      )
    }
    let question = this.state.question;
    let timelimit = question.timelimit;
    let expiryTime = question.expiry_time;
    let answer = this.state.answer;
    let modalOpen = this.state.modalOpen;
    let testSubmittedModalOpen = this.state.testSubmittedModalOpen;
    let windowChangeWarningModalOpen = this.state.windowChangeWarningModalOpen;
    console.log(timelimit)
    console.log(expiryTime)
    console.log(this.state.showAnswer)
    
    // console.log(question)
    return (
      <div style={{backgroundColor: 'white'}}>
        <div style={{position: 'fixed', top: '0', left: '0', backgroundColor: 'white', width: '100%', zIndex: '1', height: '100px' }}>
          <div style={{backgroundColor: 'white', overflow: 'hidden'}}>
            <div style={{display: 'flex', flexDirection: 'row'}}>
              <div style={{margin:'auto',marginTop:'15px',marginLeft:'1.3em', fontSize: '18px',fontWeight: '600', display: 'flex', flexDirection: 'row', textAlign: 'left'}}>
                <img style={{width: '12px'}} src="/images/hourglass.svg"></img>&nbsp;<span>
                  <ProgressBar questionId={question.id} updateTimers={this.updateTimers} timelimit={expiryTime < timelimit ? expiryTime : timelimit} handleTimeout={this.handleSubmit} />
                </span>
                </div>
              <div style={{margin: 'auto', marginRight: '1.5em'}}>
                <div className='submitButton' onClick={this.handleSubmit}>Submit Question</div>
              </div>
            </div>

            {/* <Flex>
              <div style={{margin: '1em 1.5em 0 1.5em', fontSize: '16px', fontWeight: '600'}}>
                  {+(qid) + 1} of {questions.length}
              </div>
              <div style={{margin: '1em 1.5em 0 auto ', width: '30px', marginRight: '1.5em', justifyContent: 'flex-end',display: 'flex', flexDirection: 'row'}}>
                {qid != 0 ? 
                  <img style={{marginRight: '20px'}} onClick={this.previousQuestion} src="/images/backArrow.svg"></img>
                  : null}
                {qid + 1 != questions.length ? 
                  <img onClick={this.nextQuestion} src="/images/frontArrow.svg"></img>
                  : null}
              </div>
            </Flex> */}
            {/* <div style={{margin: '1em 1.5em'}}>
                <div style={{width: '100%', height: '6px', display: 'flex', flexDirection: 'row'}}>
                  <div className='gradient' style={{width: progress+ '%'}}></div>
                  <div className='greyProgress' style={{width: greyWidth + '%', backgroundColor: '#eee'}} ></div>

                </div>

            </div> */}
        </div>
        </div>
        <LayoutWrapper style={{marginTop: '80px'}} large={true} id='questionArea'>
          {this.state.showShimmer ? <Shimmer /> :
            <GridLayout>
              <Flex column>
                <Box><Equation blooms={question.blooms_level} math_type={question.math_type} bold equation={question.name}></Equation></Box>
                {question.media === 1 && (
                  <Image center>
                    <img src={question.question_img} alt="" />
                  </Image>
                )}
                <Hint alignCenter>
                    {/* <div style={{ cursor: "pointer" }} onClick={this.handleBookMark}>
                          <span>{question_answers[qid].isBookMarked ? 'Marked For Review' : 'Mark For Review'}</span>
                    </div> */}
                    <div style={{margin: 'auto', marginRight: '5px', display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                      <div style={{ cursor: "pointer", marginRight: '10px' }}>
                        <Report testId={tid} questionId={question.id} ></Report>
                      </div>
                      <div style={{ cursor: "pointer", margin: '0', padding: '0' }} onClick={this.addOrDeleteBookmark}>
                          {question.is_bookmarked === 1 ?
                            <img style={{ color: 'white', width: '20px', height: '18px' }} src="/images/bookmarked.svg"></img>
                            :
                            <img style={{ color: 'white', width: '20px', height: '18px' }} src="/images/Bookmark.svg"></img>
                          }
                      </div>
                    </div>
                  </Hint>

                <div style={{display: 'flex', flexDirection: 'column', marginTop: '10px'}}>
                  {question.options.map(
                    ({ id, name, media, option_img, is_answer }, i) => {
                      let is_selected = true ? this.state.selected_option === id : false

                      return <div key={i} onClick={() => this.handleCheck(id, is_answer)} className={ this.state.selected_option === id ? 'gradient2' : 'gradient1'}>
                          {is_answer == 1 && is_selected && this.state.showAnswer &&
                           <img style={{ height: '20px', position: 'absolute', right: '5px' }} src="/images/white_tick-mark.png"></img>
                          }
                          {is_answer == 1 && !is_selected && this.state.showAnswer &&
                           <img style={{ height: '20px', position: 'absolute', right: '5px' }} src="/images/green_tick-mark.png"></img>
                          }
                        <div className="qNo"><p style={{margin: '0.2em 0'}}>{i + 1}</p></div>
                        <div style={{ paddingLeft: '30px', paddingRight: '20px' }}>
                          <Equation answered={answer.question_option_id === id} math_type={question.math_type} equation={name}></Equation>
                          {media === 1 && <img src={option_img} alt="" />}
                        </div>
                      </div>
                    }
                  )}
                </div>
              </Flex>

            </GridLayout>}



          {/* <Modal
            open={modalOpen}
            handleModalToggle={this.handleModalToggle}
            handleSubmit={this.handleSubmit}
            dialogTitle={this.state.dialogTitle}
          /> */}
          <Modal1
            open={testSubmittedModalOpen}
            callBack={this.testSubmittedOnLeavingWindow}
            dialogTitle={this.state.dialogTitle}
          />
        </LayoutWrapper>
        
        <style jsx='true' scoped>{`
          .mqCard{
            display: inline-block;
            width: 80px;
            margin: 5px;
            height: 60px;
            border: solid 1px #9E9E9E;
            border-radius: 5px;
            background: white;
            color:gray;
            transform:unset;
            box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
            span{
                position: relative;
                left: 5px;
                font-size: 11px;
                color:gray;
                pre{
                    margin:0px;
                }
            }
          }
          .mqCardActive{
            display: inline-block;
            width: 80px;
            margin: 5px;
            height: 60px;
            border: solid 1px #9E9E9E;
            border-radius: 5px;
            background:
              linear-gradient(to right bottom, #7175E0 0%, #4D50CB 32.912%, #E25BC8 100%) padding-box, 
              linear-gradient(to right bottom, #7175E0 0%, #4D50CB 32.912%, #E25BC8 100%) border-box;
            color:white;
            transform:scale(1.1);
            box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
            span{
                position: relative;
                left: 5px;
                font-size: 11px;
                color:white;
                pre{
                    margin:0px;
                }
            }
          }
          .submitButton{
            background:
              linear-gradient(to right bottom, #7175E0 0%, #4D50CB 32.912%, #E25BC8 100%) padding-box, 
              linear-gradient(to right bottom, #7175E0 0%, #4D50CB 32.912%, #E25BC8 100%) border-box;
              margin: auto;
              float: right;
              margin-top: 12px;
              padding: 0.2em 1em;
              border-radius: 16px; 
              font-size: 16px;
              font-weight: 600;
              color: white;
              border: none;
              cursor: pointer;
              &:focus{
                outline:0;
              }
              @media (max-width: 768px) {
                display: block;
            }
          }
          .qNo{
            position: absolute;
            left: 5px;
            top: 6px;
            width: 20px;
            height: 20px;
            border-radius: 10px;
            text-align: center;
            background: #EEEEEE;
            font-size: 10px;
          }
          .gradient1{
            background: 
              linear-gradient(#fff,#fff) padding-box, 
              linear-gradient(to right bottom, #FFFFFF 0%, #4E54C8 39.777%, #DD92D8 100%) border-box;
            color: #313149;
            padding:10px;
            border: 2px solid transparent;
            border-radius:10px;
            display:inline-block;
            margin-bottom: 10px;
            position: relative;
            text-align: center;
            height: 100%;
          }

          .gradient2{
            background: 
              linear-gradient(to right bottom, #7175E0 0%, #4D50CB 32.912%, #E25BC8 100%) padding-box, 
              linear-gradient(to right bottom, #7175E0 0%, #4D50CB 32.912%, #E25BC8 100%) border-box;
            color: #313149;
            padding:10px;
            border: 2px solid transparent;
            border-radius:10px;
            display:inline-block;
            margin-bottom: 10px;
            position: relative;
            text-align: center;
            height: 100%;
          }
          .gradient{
            background:linear-gradient(to right bottom, #7175E0 0%, #4D50CB 32.912%, #E25BC8 100%) padding-box;
            border: 1px transparent;
            display: inline-block;
            border-top-left-radius: 8px;
            border-bottom-left-radius: 8px;


          }
          .greyProgress{
            border-top-right-radius: 8px;
            border-bottom-right-radius: 8px;
          }
        
        
        `}
        </style>

      </div>
    );
  }
}

export default TestStart;
